module.exports = __webpack_public_path__ + "img/pin-veilig.a5566c4c.svg";